import { render } from "./ProjectAccess.vue?vue&type=template&id=a85622c6&scoped=true"
import script from "./ProjectAccess.vue?vue&type=script&lang=js"
export * from "./ProjectAccess.vue?vue&type=script&lang=js"

import "./ProjectAccess.vue?vue&type=style&index=0&id=a85622c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85622c6"],['__file',"src/components/admin/ProjectAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a85622c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a85622c6', __exports__)) {
    api.reload('a85622c6', __exports__)
  }
  
  module.hot.accept("./ProjectAccess.vue?vue&type=template&id=a85622c6&scoped=true", () => {
    api.rerender('a85622c6', render)
  })

}


export default __exports__